/**
 * Hybrid Pagination component.
 * Routes between the Tailwind implementation (preferred) and the
 * styled-components implementation (for consumers using system props).
 */

import { hasStyledProps } from "@sproutsocial/seeds-react-system-props";
import { PaginationStyled } from "./PaginationStyled";
import { PaginationTailwind } from "./PaginationTailwind";
import type { PaginationProps } from "./PaginationTypes";

export const PaginationHybrid = (props: PaginationProps) => {
  // Pagination exposes domain props plus an optional className, none of which
  // are styled-system props, so hasStyledProps is effectively always false; the
  // styled-components branch is retained as a pattern-conformance fallback.
  if (hasStyledProps(props)) {
    return <PaginationStyled {...props} />;
  }
  return <PaginationTailwind {...props} />;
};
